<script setup lang="tsx">
import { ref, watchEffect } from "vue";
import { __color } from "@zyzgroup/core-web";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {}
);

const mappedState = mapState(["color.redCommon"]);

const color = ref();
const oppositeColor = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.redCommon"].value;
  oppositeColor.value = __color.set(color.value).opposite(true).toString();
});
</script>

<template>
  <!-- 不设置 width="64" height="64" 自适应父元素 -->
  <!-- viewBox : x y width height , 可重设 viewBox 切除四周多余空白 -->
  <svg
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="none"
    fill="none"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <path
      d="M32 62C48.5685 62 62 48.5685 62 32C62 15.4315 48.5685 2 32 2C15.4315 2 2 15.4315 2 32C2 48.5685 15.4315 62 32 62Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.8685 32L44.4044 22.4642C45.1985 21.67 45.1985 20.3898 44.4044 19.5956C43.6102 18.8015 42.33 18.8015 41.5358 19.5956L32 29.1315L22.4642 19.5956C21.67 18.8015 20.3898 18.8015 19.5956 19.5956C18.8015 20.3898 18.8015 21.67 19.5956 22.4642L29.1315 32L19.5956 41.5358C18.8015 42.33 18.8015 43.6102 19.5956 44.4044C20.3898 45.1985 21.67 45.1985 22.4642 44.4044L32 34.8685L41.5358 44.4044C42.33 45.1985 43.6102 45.1985 44.4044 44.4044C45.1985 43.6102 45.1985 42.33 44.4044 41.5358L34.8685 32Z"
      :fill="oppositeColor"
    />
  </svg>
</template>
